var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-6 text-pro-description p-0" },
      [
        _c("span", { attrs: { id: "skill-airbnb" } }, [
          _c("img", {
            attrs: { src: "/static/img/ic-airbnb.svg", width: "20" }
          }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("message.professional.skills.airbnb")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("b-popover", {
          attrs: {
            target: "skill-airbnb",
            placement: "bottom",
            triggers: "hover",
            content: _vm.$t("message.professional.skills.airbnb_detail")
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6 text-pro-description p-0" },
      [
        _c("span", { attrs: { id: "skill-home" } }, [
          _c("img", { attrs: { src: "/static/img/ic-home.svg", width: "20" } }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.professional.skills.home")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("b-popover", {
          attrs: {
            target: "skill-home",
            placement: "bottom",
            triggers: "hover",
            content: _vm.$t("message.professional.skills.home_detail")
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-6 mt-3 text-pro-description p-0" },
      [
        _c("span", { attrs: { id: "skill-office" } }, [
          _c("img", {
            attrs: { src: "/static/img/ic-office.svg", width: "20" }
          }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("message.professional.skills.office")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("b-popover", {
          attrs: {
            target: "skill-office",
            placement: "bottom",
            triggers: "hover",
            content: _vm.$t("message.professional.skills.office_detail")
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d95cae72", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d95cae72","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/CleanerSkills.vue
// module id = 1731
// module chunks = 0